<template>
  <div>
    <AppHeader/>

    <section class="pr-section blog">
      <div class="pr-container">
        <header class="blog__head">
          <span class="pr-eyebrow">PR, Media &amp; Sports Days</span>
          <h1 class="pr-title">PR Blog</h1>
        </header>

        <v-progress-linear v-if="loading && !blogs.length" indeterminate color="#002652" class="mb-8"></v-progress-linear>

        <div v-if="blogs.length" class="blog-list">
          <router-link
              v-for="item in blogs"
              :key="item.id || item.alias"
              :to="'/blog/' + item.alias"
              class="blog-item"
          >
            <div class="blog-item__media">
              <img
                  :src="item.image ? storage + item.image : require('@/assets/img/cover_2022.jpg')"
                  :alt="item.title"
                  loading="lazy"
              />
            </div>
            <div class="blog-item__body">
              <p class="blog-item__meta">
                <span class="blog-item__tag">Blog</span>
                <span v-if="formatDate(item.created_at)">{{ formatDate(item.created_at) }}</span>
              </p>
              <h2 class="blog-item__title">{{ item.title }}</h2>
              <p class="blog-item__excerpt">{{ excerpt(item.content) }}</p>
              <span class="blog-item__more">
                {{ $t('conf.read_more') }}
                <v-icon small>mdi-arrow-right</v-icon>
              </span>
            </div>
          </router-link>
        </div>

        <div v-else-if="!loading" class="blog-empty pr-card">
          <v-icon color="#1553d1">mdi-pencil-box-multiple-outline</v-icon>
          <p>{{ $t('conf.no_blogs') }}</p>
        </div>

        <div v-if="hasMore" class="blog__more">
          <button type="button" class="pr-btn pr-btn--ghost" :disabled="loading" @click="getOtherBlogs">
            {{ $t('more_blogs') }}
            <v-icon>mdi-chevron-down</v-icon>
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import AppHeader from './AppHeader';

export default {
  name: "Blog",
  components: {AppHeader},
  mounted() {
    this.getBlogs()
  },
  computed: {
    hasMore() {
      return this.blogs.length >= this.numberBlogs
    },
  },
  methods: {
    getBlogs() {
      const requestBody = {
        page: this.page,
        postsPerPage: this.numberBlogs,
        categories: ["PR Blog"],
      };
      this.loading = true
      axios
          .post("https://web-admin.sum.ba/api/web/objave", requestBody)
          .then(response => {
            this.blogs = response.data || []
          })
          .finally(() => {
            this.loading = false
          })
    },
    getOtherBlogs() {
      this.numberBlogs += 4;
      this.getBlogs();
    },
    excerpt(html, length = 220) {
      if (!html) return ''
      const text = new DOMParser().parseFromString(html, 'text/html').body.textContent.replace(/\s+/g, ' ').trim()
      return text.length > length ? text.slice(0, length).replace(/\s+\S*$/, '') + '…' : text
    },
    // API vraća "dd.mm.yyyy hh:mm:ss"
    formatDate(value) {
      const match = /^(\d{2})\.(\d{2})\.(\d{4})/.exec(value || '')
      if (!match) return ''
      return parseInt(match[1], 10) + '. ' + parseInt(match[2], 10) + '. ' + match[3] + '.'
    },
  },
  data() {
    return {
      storage: 'https://web-admin.sum.ba/api/storage/',
      blogs: [],
      page: 1,
      numberBlogs: 4,
      loading: false,
    }
  }
}
</script>

<style lang="scss" scoped>
.blog {
  padding-top: 56px;
}

.blog__head {
  margin-bottom: 48px;
  padding-bottom: 28px;
  border-bottom: 1px solid var(--pr-line);

  .pr-title {
    font-size: clamp(2.6rem, 6vw, 4.2rem);
  }
}

.blog-list {
  display: flex;
  flex-direction: column;
  gap: 64px;
}

.blog-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 56px;
  align-items: center;
  color: inherit !important;
  text-decoration: none !important;

  &:hover {
    .blog-item__media img {
      transform: scale(1.03);
    }

    .blog-item__title {
      color: var(--pr-blue);
    }

    .blog-item__more .v-icon {
      transform: translateX(4px);
    }
  }
}

.blog-item__media {
  overflow: hidden;
  border-radius: var(--pr-radius);
  background: #e9edf4;
  aspect-ratio: 1 / 1;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center 30%;
    transition: transform .6s ease;
  }
}

.blog-item__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin: 0 0 16px;
  font-size: 14px;
  color: var(--pr-muted);
}

.blog-item__tag {
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(0, 38, 82, .07);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .1em;
  text-transform: uppercase;
  color: var(--pr-navy);
}

.blog-item__title {
  margin: 0 0 18px;
  font-size: clamp(1.6rem, 3vw, 2.6rem);
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -.01em;
  color: var(--pr-navy);
  transition: color .2s ease;
}

.blog-item__excerpt {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0 0 24px;
  font-size: 1.05rem;
  line-height: 1.7;
  color: var(--pr-muted);
}

.blog-item__more {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding-bottom: 2px;
  border-bottom: 2px solid var(--pr-red);
  font-weight: 700;
  color: var(--pr-navy);

  .v-icon {
    color: inherit !important;
    transition: transform .2s ease;
  }
}

.blog-empty {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 28px;
  box-shadow: none;

  p {
    margin: 0;
    font-weight: 500;
    color: var(--pr-muted);
  }
}

.blog__more {
  display: flex;
  justify-content: center;
  margin-top: 64px;
}

@media (min-width: 1100px) {
  .blog-item__media {
    aspect-ratio: 5 / 4;
  }
}

@media (max-width: 860px) {
  .blog-list {
    gap: 48px;
  }
  .blog-item {
    grid-template-columns: 1fr;
    gap: 22px;
  }
  .blog-item__media {
    aspect-ratio: 16 / 10;
  }
}

@media (max-width: 600px) {
  .blog {
    padding-top: 36px;
  }
  .blog__head {
    margin-bottom: 32px;
    padding-bottom: 20px;
  }
}
</style>
